module.exports = __webpack_public_path__ + "img/title_news3.f8aa1712.png";